import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../MobileApp/Breadcum';
import breadcrumbData from '../Data/breadcrumbData';
import whyusData from '../Data/whyusData';
import aboutData from '../Data/aboutData';
import contactData from '../Data/contactData';
import faqData from '../Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../MobileApp/About';
import Whyus from '../MobileApp/Whyus';
import Contact from '../MobileApp/Contact';
import Faq from '../MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
 const { title, description, keywords } = seoMetaData.cloudServices;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href="https://www.cloudkode.com/services/cloud-services" />
<script type="application/ld+json">
  {`
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Which cloud platforms do you support?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We work with AWS, Azure, and Google Cloud Platform — offering hybrid and multi-cloud setups as well."
        }
      },
      {
        "@type": "Question",
        "name": "Can I migrate to the cloud without downtime?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we offer near-zero downtime migration strategies for business-critical workloads."
        }
      },{
        "@type": "Question",
        "name": "Do you help reduce cloud cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. We optimize your cloud usage to eliminate waste and reduce your monthly bills."
        }
      },{
        "@type": "Question",
        "name": "What's the difference between public, private ,and hybrid cloud?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Public cloud is shared, private cloud is dedicated, and hybrid combines both for flexibility and control."
        }
      },{
        "@type": "Question",
        "name": "Is the cloud secure?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, when implemented correctly. We use advanced security features, firewalls, IAM, and compliance tools."
        }
      },{
        "@type": "Question",
        "name": "Do you offer cloud backup and disaster recovery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we implement robust DR solutions and data backup plans for business continuity."
        }
      },{
        "@type": "Question",
        "name": "Can you monitor and manage my cloud infrastructure?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we offer 24/7 monitoring, performance optimization, and SLA-based support."
        }
      },{
        "@type": "Question",
        "name": "What's included in your cloud consulting service?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We assess your current setup, recommend improvements, plan migration, and handle full implementation."
        }
      },{
        "@type": "Question",
        "name": "Do I own my cloud data?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, your data is always your property. We ensure proper access control and data portability."
        }
      }]
    }
  `}
</script>

      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.cloud} /> 
   <About data={aboutData.cloud} />
   <Whyus data={whyusData.cloud}/>
   <Contact data={contactData.cloud}/>
   <Faq data={faqData.cloud}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
